import { isNull } from 'lodash';
import { ProjectInspection } from './api/projectInspection';

export type InspectionFindingCount = {
  totalFindings: number;
  openFindings: number;
  openFindingsRequiredForCert: number;
};

export const getFindingCounts = (
  inspection: ProjectInspection,
): InspectionFindingCount => {
  let totalFindings = 0;
  let openFindings = 0;
  let openFindingsRequiredForCert = 0;

  const disableCarryOvers =
    inspection &&
    inspection.project &&
    inspection.project.client.disable_carry_overs;
  const templateId = inspection && inspection.inspection_template;

  if (inspection.findings) {
    inspection.findings.forEach((finding: any) => {
      if (disableCarryOvers && finding.InspectionFindingModel.carried_over) {
        return;
      }
      totalFindings += 1;

      if (isNull(finding.date_completed)) {
        openFindings += 1;
        if (
          templateId &&
          inspection.findingDetails?.find(
            (fd: any) =>
              fd.finding_type_id === finding.finding_type_id &&
              fd.inspection_template_id === templateId.id &&
              fd.is_required_for_cert,
          ) !== undefined
        ) {
          openFindingsRequiredForCert += 1;
        }
      }
    });
  }

  return {
    totalFindings,
    openFindings,
    openFindingsRequiredForCert,
  };
};
